import React, {useContext, useEffect, useState} from "react";
import {MapContainer, TileLayer} from 'react-leaflet'
import {useCurrentPosition} from "../../../../../../../JsonScreen/Screen/ScreenComponents/Maps/hooks";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {Icon} from "@material-ui/core";
import {useDrop} from "react-dnd";
import {AcceptTypes} from "../../../ToolBar/ToolBarUtils/ItemTypes";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";

const useStyles = makeStyles(() => ({
    mapsChildrenContainer: {
        height: 50,
        width: '100%',
        position: 'absolute',
        bottom: 5,
        left: 0,
        zIndex: 999,
        //  borderTop: '1px dashed',
        display: 'flex',
        alignItems: 'center',
        padding: 10
    },
    item: {
        padding: 5,
        cursor: 'pointer',
        margin: 5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 54,
        background: 'rgba(232,243,255,0.71)'
    }

}));
const Maps = (props) => {
    const [currentLocation, setCurrentLocation] = useState(null);
    const [location, error] = useCurrentPosition();
    const {component: {children}, properties, path} = props;
    const {onSelectComponent, onMoveComponent, onDropComponent} = useContext(ScreenDesignerContextNew);
    useEffect(() => {
        if (!location) return;
        setCurrentLocation([location.coords.latitude, location.coords.longitude])
    }, [location]);


    const [{isOverCurrent, canDrop}, drop] = useDrop({
        accept: AcceptTypes.maps,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
            canDrop: monitor.canDrop()
        }),
        drop: (item, monitor) => {
            const didDrop = monitor.didDrop();
            if (didDrop) {
                return;
            }
            if (item.dragType === 'move') {
                return
            }
            onDropComponent(item, 0, `${path}.children`)
        }
    });


    if (!currentLocation) return <>Waiting for location</>;
    return (
        <div style={{height: '100%', width: '100%', position: 'relative'}} ref={drop}>
            <MapContainer
                center={currentLocation}
                zoom={10}
            >
                <TileLayer
                    attribution='&copy; SysbuPro'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <MapsChildrenArea
                    children={children}
                    onSelectComponent={onSelectComponent}
                    path={path}
                />
            </MapContainer>
        </div>


    )
};

export default Maps;

const MapsChildrenArea = (props) => {
    const {children = [], onSelectComponent, isSelected, path} = props;
    const classes = useStyles();

    return (
        <div className={classes.mapsChildrenContainer}>
            {children.map((item, index) => {
                return (
                    <div
                        key={index} className={classes.item}
                        onClick={(e) => {
                            e.stopPropagation();
                            onSelectComponent(item, `${path}.children.${index}`)
                        }}
                    >
                        <Icon>
                            {item.type === 'marker' ? 'fmd_good' : 'location_searching'}
                        </Icon>
                        <div>
                            {item.type}
                        </div>
                    </div>
                )
            })}
        </div>
    )
};